import { render, staticRenderFns } from "./T-F-Grad-2022.vue?vue&type=template&id=e7a38e10&scoped=true"
import script from "./T-F-Grad-2022.vue?vue&type=script&lang=js"
export * from "./T-F-Grad-2022.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a38e10",
  null
  
)

export default component.exports